var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.visible,
            width: "1400px",
            "custom-class": "email-detail-dialog",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            }
          }
        },
        [
          _vm.showUnlinkedReplyPopup
            ? _c("send-new-email", {
                attrs: { "message-for-replying": _vm.message },
                on: { close: _vm.toggleUnlinkedReplyPopup }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-row",
            { ref: "toolbar", staticClass: "toolbar", attrs: { gutter: 5 } },
            [
              _c("el-col", [
                _c(
                  "div",
                  { staticClass: "button-group mb-10" },
                  [
                    !_vm.selectedLegalEntityStore
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: _vm.$t("messages.selectSubEntity"),
                              placement: "top"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: !!!_vm.selectedLegalEntityStore,
                                  size: "mini",
                                  type: "primary",
                                  icon: "el-icon-message"
                                },
                                on: { click: _vm.toggleUnlinkedReplyPopup }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.$t("messages.reply")) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: !!!_vm.selectedLegalEntityStore,
                              size: "mini",
                              type: "primary",
                              icon: "el-icon-message"
                            },
                            on: { click: _vm.toggleUnlinkedReplyPopup }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("messages.reply")) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        ),
                    _vm._v(" "),
                    !_vm.message ||
                    !_vm.message.message_recipients ||
                    _vm.message.message_recipients.length === 0
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: _vm.$t("messages.noUnlinked"),
                              placement: "top"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled:
                                    !_vm.message ||
                                    !_vm.message.message_recipients ||
                                    _vm.message.message_recipients.length === 0,
                                  size: "mini",
                                  type: "primary",
                                  icon: "el-icon-message"
                                },
                                on: { click: _vm.toggleUnlinkedReplyPopup }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("messages.sendAccountOverview")
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _c(
                          "el-button",
                          {
                            attrs: {
                              disabled:
                                !_vm.message ||
                                !_vm.message.message_recipients ||
                                _vm.message.message_recipients.length === 0,
                              loading:
                                _vm.sendAccountOverviewActionEmailLoading,
                              size: "mini",
                              type: "primary",
                              icon: "el-icon-message"
                            },
                            on: { click: _vm.handleNewMessage }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("messages.sendAccountOverview")) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        ),
                    _vm._v(" "),
                    !_vm.message ||
                    !_vm.message.message_recipients ||
                    _vm.message.message_recipients.length === 0
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "info",
                              icon: "el-icon-link"
                            },
                            on: { click: _vm.handleLink }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("messages.link")) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.message &&
                    _vm.message.message_recipients &&
                    _vm.message.message_recipients.length > 0
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "info",
                              icon: "el-icon-link"
                            },
                            on: { click: _vm.handleUnlink }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("messages.unlink")) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.message?.archived_at
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-delete",
                              type: "info",
                              size: "mini"
                            },
                            on: { click: _vm.handleUnarchive }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("messages.unarchive")) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.message?.archived_at
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-delete",
                              type: "info",
                              size: "mini"
                            },
                            on: { click: _vm.handleArchive }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("messages.archive")) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { style: _vm.modalContentStyle, attrs: { gutter: 5 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "no-shadow el-card-sm-padding" },
                    [
                      _c(
                        "el-row",
                        { staticClass: "detail-row mb-10" },
                        [
                          _c("el-col", { attrs: { span: 4 } }, [
                            _c("span", [_vm._v(_vm._s(_vm.$t("from")) + ":")])
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 20 } }, [
                            _c("span", [_vm._v(_vm._s(_vm.message?.from_))])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "detail-row mb-10" },
                        [
                          _c("el-col", { attrs: { span: 4 } }, [
                            _c("span", [_vm._v(_vm._s(_vm.$t("to")) + ":")])
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 20 } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.message?.metadata?.email?.to))
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.extractEmails(_vm.message?.metadata?.email?.cc)
                        ? _c(
                            "el-row",
                            { staticClass: "detail-row mb-10" },
                            [
                              _c("el-col", { attrs: { span: 4 } }, [
                                _c("span", [_vm._v(_vm._s(_vm.$t("Cc")) + ":")])
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 20 } }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.extractEmails(
                                        _vm.message?.metadata?.email?.cc
                                      )
                                    )
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.extractEmails(_vm.message?.metadata?.email?.bcc)
                        ? _c(
                            "el-row",
                            { staticClass: "detail-row mb-10" },
                            [
                              _c("el-col", { attrs: { span: 4 } }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("bcc")) + ":")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 20 } }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.extractEmails(
                                        _vm.message?.metadata?.email?.bcc
                                      )
                                    )
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "detail-row mb-10" },
                        [
                          _c("el-col", { attrs: { span: 4 } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("subject")) + ":")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 20 } }, [
                            _c("span", [_vm._v(_vm._s(_vm.message?.subject))])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "detail-row mb-10" },
                        [
                          _c("el-col", { attrs: { span: 4 } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("received")) + ":")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 20 } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.formatDate(_vm.message?.received_at))
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "detail-row mb-10" },
                        [
                          _c("el-col", { attrs: { span: 4 } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("messages.ref")) + ":")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 20 } },
                            [
                              _vm.message?.message_recipients?.length
                                ? _vm._l(
                                    _vm.message.message_recipients,
                                    function(message_recipient) {
                                      return _c(
                                        "div",
                                        {
                                          key: message_recipient.reference,
                                          staticClass: "mb-5"
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "hover-underline fc-blue text-ellipsis",
                                              attrs: {
                                                to: {
                                                  name: "recipient-detail",
                                                  params: {
                                                    id:
                                                      message_recipient
                                                        .recipient_by_reference
                                                        .reference,
                                                    participant:
                                                      _vm.selectedParticipantStore
                                                  }
                                                }
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.handleClose.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    message_recipient
                                                      .recipient_by_reference
                                                      .account_id
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }
                                  )
                                : _c("span", { attrs: { type: "info" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("messages.no_references"))
                                    )
                                  ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "detail-row mb-10" },
                        [
                          _c("el-col", { attrs: { span: 4 } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("messages.assignee")) + ":")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 20 } },
                            [
                              _vm.message?.message_assignees?.length
                                ? _vm._l(
                                    _vm.message.message_assignees,
                                    function(message_assignee) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: message_assignee.reference,
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                            closable: ""
                                          },
                                          on: {
                                            close: function($event) {
                                              return _vm.handleUnassign(
                                                message_assignee
                                                  ?.person_by_reference
                                                  ?.reference
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                message_assignee
                                                  ?.person_by_reference
                                                  ?.username
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    }
                                  )
                                : _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        value: null,
                                        size: "mini",
                                        placeholder: _vm.$t(
                                          "messages.assign_to"
                                        ),
                                        disabled: _vm.assignLoading
                                      },
                                      on: { change: _vm.handleAssign }
                                    },
                                    _vm._l(_vm.participantUsers, function(
                                      user
                                    ) {
                                      return _c("el-option", {
                                        key: user.person_by_reference.reference,
                                        attrs: {
                                          label:
                                            user.person_by_reference.username,
                                          value:
                                            user.person_by_reference.reference
                                        }
                                      })
                                    }),
                                    1
                                  )
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.visible
                        ? _c("div", { staticClass: "email-body" }, [
                            _c("iframe", {
                              attrs: {
                                srcdoc: _vm.message?.metadata?.email?.body?.html
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.message?.message_attachments &&
                      _vm.message.message_attachments.length > 0
                        ? _c("div", { staticClass: "attachments" }, [
                            _c("h2", [_vm._v(_vm._s(_vm.$t("attachments")))]),
                            _vm._v(" "),
                            _c(
                              "div",
                              _vm._l(_vm.message.message_attachments, function(
                                attachment
                              ) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: attachment.reference,
                                    staticClass: "attachment-tag",
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function($event) {
                                        return _vm.downloadAttachment(
                                          attachment.attachment_by_reference
                                            .metadata
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("svg-icon", {
                                      attrs: { "icon-class": "paperclip-solid" }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          attachment.attachment_by_reference
                                            .metadata.name
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("link-recipient-dialog", { ref: "linkRecipientDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }